import Dinero from 'dinero.js';
import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { RoyaltiesAccount } from '@services/royalties/types/royalties-account';
import { PayoutHistory } from '@services/royalties/types/payout-history';
import { RoyaltiesAccountType } from '@services/royalties/types/royalties-account-type';
import { Action } from 'redux';

export class GetRoyaltiesAccount implements LoadingAction {
  readonly type = actions.GET_ROYALTIES_ACCOUNT;
  readonly isLoading = true;
}

export class GetRoyaltiesAccountSuccess implements LoadingAction {
  readonly type = actions.GET_ROYALTIES_ACCOUNT_SUCCESS;
  readonly isLoading = false;

  constructor(public royaltiesAccount: RoyaltiesAccount) {}
}

export class GetRoyaltiesAccountError implements ErrorAction {
  readonly type = actions.GET_ROYALTIES_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class DeleteRoyaltiesAccount implements LoadingAction {
  readonly type = actions.DELETE_ROYALTIES_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class DeleteRoyaltiesAccountSuccess implements LoadingAction {
  readonly type = actions.DELETE_ROYALTIES_ACCOUNT_SUCCESS;
  readonly isLoading = false;
}

export class DeleteRoyaltiesAccountError implements ErrorAction {
  readonly type = actions.DELETE_ROYALTIES_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RegisterRoyaltiesAccount implements LoadingAction {
  readonly type = actions.REGISTER_ROYALTIES_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public code: string) {}
}

export class RegisterRoyaltiesAccountSuccess implements LoadingAction {
  readonly type = actions.REGISTER_ROYALTIES_ACCOUNT_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public royaltiesAccount: RoyaltiesAccount) {}
}

export class RegisterRoyaltiesAccountError implements ErrorAction {
  readonly type = actions.REGISTER_ROYALTIES_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListPayouts implements LoadingAction {
  readonly type = actions.LIST_PAYOUTS;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class ListPayoutsSuccess implements LoadingAction {
  readonly type = actions.LIST_PAYOUTS_SUCCESS;
  readonly isLoading = false;

  constructor(public payouts: PayoutHistory[]) {}
}

export class ListPayoutsError implements ErrorAction {
  readonly type = actions.LIST_PAYOUTS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetBalance implements LoadingAction {
  readonly type = actions.GET_BALANCE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor (public accountId?: string) {}
}

export class GetBalanceSuccess implements LoadingAction {
  readonly type = actions.GET_BALANCE_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public balance: Dinero.Dinero, public accountId?: string) {}
}

export class GetBalanceError implements ErrorAction {
  readonly type = actions.GET_BALANCE_ERROR;
  readonly isError = true;

  constructor(public code: string, public accountId?: string) {}
}

export class GetStatements implements LoadingAction {
  readonly type = actions.GET_STATEMENTS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor (public accountId?: string) {}
}

export class GetStatementsSuccess implements LoadingAction {
  readonly type = actions.GET_STATEMENTS_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public statements: any[], public accountId?: string) {}
}

export class GetStatementsError implements ErrorAction {
  readonly type = actions.GET_STATEMENTS_ERROR;
  readonly isError = true;

  constructor(public code: string, public accountId?: string) {}
}

export type RoyaltiesAccountActions =
  | GetRoyaltiesAccount
  | GetRoyaltiesAccountSuccess
  | GetRoyaltiesAccountError
  | DeleteRoyaltiesAccount
  | DeleteRoyaltiesAccountSuccess
  | DeleteRoyaltiesAccountError
  | RegisterRoyaltiesAccount
  | RegisterRoyaltiesAccountSuccess
  | RegisterRoyaltiesAccountError
  | ListPayouts
  | ListPayoutsSuccess
  | ListPayoutsError
  | GetBalance
  | GetBalanceSuccess
  | GetBalanceError
  | GetStatements
  | GetStatementsSuccess
  | GetStatementsError;

export class ResetNewRoyaltiesAccount implements Action {
  readonly type = actions.RESET_NEW_ROYALTIES_ACCOUNT;

  constructor(
    public accountType: RoyaltiesAccountType,
    public data?: Partial<RoyaltiesAccount>
  ) {}
}

export class UpdateRoyaltiesAccountField<
  T extends RoyaltiesAccount,
  U extends keyof T
> implements Action
{
  readonly type = actions.UPDATE_FIELD;
  constructor(public field: U, public value?: T[U]) {}
}
